import { GridRowModel } from "@mui/x-data-grid";
import { ToastNotificationProps } from "../ToastNotification";
import { AZURE_AD_TOKEN_EXPIRED_MESSAGE, HTTP_STATUS_CODE_FORBIDDEN } from "../constants";
import { ApiException, MockMember } from "../useApiClient/UtilityClientProxy.generated";
import { useSearchMembers } from "../utilityApi";

export async function PopulateGrid(
  setRows: (state: GridRowModel[]) => void,
  setIsLoading: (state: boolean) => void,
  setNotificationState: (notificationState: ToastNotificationProps) => void,
) {
  const searchMembers = useSearchMembers();
  const clearGrid = () => {
    setRows([]);
  };

  try {
    setIsLoading(true);

    const response = await searchMembers();

    if (response.result === undefined || response.result.length === 0) {
      clearGrid();
    } else {
      const members = response.result;
      const rows = members.map((member: MockMember) => {
        return { id: member.contactId, ...member };
      });

      setRows(rows);
    }
  } catch (error: any) {
    if (error.status === HTTP_STATUS_CODE_FORBIDDEN) {
      clearGrid();
      setNotificationState({
        message: AZURE_AD_TOKEN_EXPIRED_MESSAGE,
        apiException: error as ApiException,
      });
    }
  } finally {
    setIsLoading(false);
  }
}
